module.exports = __webpack_public_path__ + "static/media/Home Page_website-12.07539474.png";